import { useTranslation } from '@frontend/i18n';
import { Modal, ModalControlModalProps } from '@frontend/design-system';

export type ThingsToKnowModalProps = {
  modalProps: ModalControlModalProps;
};

export const ThingsToKnowModal = ({ modalProps }: ThingsToKnowModalProps) => {
  const { t } = useTranslation('payments');

  return (
    <Modal {...modalProps} maxWidth={600} minWidth={600}>
      <Modal.Header onClose={modalProps.onClose}>{t('Things to Know')}</Modal.Header>
      <Modal.Body>
        <ul>
          <li>{t("Payments won't write back, even where we support it elsewhere.")}</li>
          <li>{t("Child contacts can't be linked to a parent or head of household.")}</li>
          <li>{t('Any Payments user can manage the account, not just admins.')}</li>
        </ul>
      </Modal.Body>
      <Modal.Footer
        secondary={{
          label: t('Okay'),
          onClick: modalProps.onClose,
        }}
      />
    </Modal>
  );
};
